import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {API_URL} from "../utils/api";
import axios  from "axios";
import { ToastContainer, toast } from 'react-toastify';
 
const AddPriceLayer = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [group_name, setGroupName] = useState("");
  const [location, setLocation] = useState("");
  const [service_id, setServiceID] = useState("");
  const [price, setPrice] = useState("");
  const [comments, setComment] = useState("");
 
    const [groupNameErr, setGroupNameErr] = useState(false);
    const [priceErr, setPriceErr] = useState(false);
    const [serviceIDErr, setServiceIDErr] = useState(false);
    const [locationErr, setLocationErr] = useState(false);
    const [commentErr, setCommentErr] = useState(false);

    const [formData, setFormData] = useState({
        service_id:"",
       price: "", 
       comments: "",
       group_name: "", 
       location: ""
      });
   
    async function fetchPriceInfo() {
        axios
          .get(process.env.REACT_APP_API_BASE_URL+"price-details/" + id)
          .then((res) => {
            // return false;
            if (res.data) {
                
                setGroupName(res.data.group_name);
                setLocation(res.data.location);
                setServiceID(res.data.service_id);
                setPrice(res.data.price);
                setComment(res.data.comments);
               setFormData({
                  service_id: res.data.service_id,
                 price: res.data.price, 
                 comments: res.data.comments,
                 group_name: res.data.group_name, 
                 location: res.data.location
                });
                       
            } else {
              toast.success("something went wrong...");
            }
          })
          .catch((err) => {
            console.error(err);
            alert(err);
          });
      }
    
      useEffect(() => {
       if(id){ 
         fetchPriceInfo();
         } else{
          setFormData({ ...formData,   service_id: "", price: "", comments: "", group_name: "",  location: "" });
          setGroupName("");
          setLocation("");
          setServiceID("");
          setPrice("");
          setComment("");
         }
      }, [id]);
      
      const [servicesList, setServicesList] = useState([]);

      useEffect(() => {
          // Fetch data
          axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
              .then(response => {
                setServicesList(response.data.data);
              })
              .catch(error => {
                  console.error('Error fetching data:', error);
              });
      }, []);
       
  const handleSubmit = () => {

    if(service_id != "" && price != "" && location != '' && group_name!="" && comments!=""){
    var formData = {
        service_id : service_id,
      price : price,
      location : location,
      group_name:group_name,
      comments: comments
    };
    console.log(formData);
if(id){

    axios.post(process.env.REACT_APP_API_BASE_URL+"price-update/"+id, { ...formData })
    .then((res) => {
        console.log(res.data);
        // return false;
      if(res.data.status==true){
          toast.success('Price updated sucessfully!!');
          setTimeout(() => {
            navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/price-management');
          }, 2000);
      }
      else{
        alert("something went wrong...")
      }
    })
    .catch(err => {
      console.error(err);
      alert(err);
    });


}else{

    axios.post(process.env.REACT_APP_API_BASE_URL+"price-add", { ...formData })
    .then((res) => {
        console.log(res.data);
        // return false;
      if(res.data.status==true){
          toast.success('Price added sucessfully!!');
          setTimeout(() => {
            navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/price-management');
          }, 2000);
      }
      else{
        alert("something went wrong...")
      }
    })
    .catch(err => {
      console.error(err);
      alert(err);
    });

}
    } else{

      if(service_id == ""){
        setServiceIDErr(true);
      }
       if(price == ""){
        setPriceErr(true);
      }
       if(location == ''){
        setLocationErr(true);
      }
       if(comments== ''){
        setCommentErr(true);
      }
      if(group_name== ''){
        setGroupNameErr(true);
      }
    }

  }

  
  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Add New Price</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
          <div>
                <label className='form-label fw-bold text-neutral-900'
                htmlFor="location">
                  Location:{" "}
                </label>
                <select onChange={(e) =>{
                   setLocation(e.target.value)
                   setLocationErr(false);
                   if(e.target.value == ""){
                    setLocationErr(true);
                   }
                   }} 
                 id="location"   name="location"    value={location}   className={locationErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
              >
                  <option value=''>Select Location</option>
                  <option value='1'>Liverpool, NSW</option>
                  <option value='2'>Drummoyne, NSW</option>
                </select>
                {locationErr && (
                        <span className="error-message">
                            {'Location is mandatory'}
                        </span>
                    )} 
              </div>
              
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='group_name'
                >
                 Group Name:{" "}
                </label>
                <input
                  onChange={(e) =>{
                     setGroupName(e.target.value)
                     setGroupNameErr(false);
                     if(e.target.value == ""){
                        setGroupNameErr(true);
                     }
                  }
                  }
                  type='text'
                  className={groupNameErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                  id='group_name'
                  name='group_name'
                  value={group_name}
                  placeholder='Enter Group Name'
                />
                  {groupNameErr && (
                        <span className="error-message">
                            {'Group Name is mandatory'}
                        </span>
                    )} 
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'   htmlFor='serviceID'>
                 Choose Service:{" "}
                </label>
                <select onChange={(e) =>{
                   setServiceID(e.target.value)
                   setServiceIDErr(false);
                   if(e.target.value == ""){
                    setServiceIDErr(true);
                   }
                   }} 
                   value={service_id}
                 id="serviceID"   name="service_id"   className={serviceIDErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
              >
                  <option value=''>Select Services</option>
                  {servicesList.map((service, index)=>(
 <option value={service.id}>{service.title}</option>
                 
                  ))}
                   </select>
                {serviceIDErr && (
                        <span className="error-message">
                            {'Service is mandatory'}
                        </span>
                    )} 
              </div>
               
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='price'
                >
                Price($):{" "}
                </label>
                <input
                  onChange={(e) =>{
                     setPrice(e.target.value)
                     setPriceErr(false);
                     if(e.target.value == ""){
                        setPriceErr(true);
                     }
                  }
                  }
                  type='float'
                  className={priceErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                  id='price'
                  name='price'
                  value={price}
                  placeholder='Enter Price'
                />
                  {priceErr && (
                        <span className="error-message">
                            {'Price is mandatory'}
                        </span>
                    )}

 
              </div>

              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='comments'
                >
                Comment:{" "}
                </label>
                <input
                  onChange={(e) =>{
                     setComment(e.target.value)
                     setCommentErr(false);
                     if(e.target.value == ""){
                        setCommentErr(true);
                     }
                  }
                  }
                  type='float'
                  value={comments}
                  className={commentErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                  id='comments'
                  name='comments'
                  placeholder='Enter Comment'
                />
                  {commentErr && (
                        <span className="error-message">
                            {'Comment is mandatory'}
                        </span>
                    )} 
              </div>

              <br />
              <button onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddPriceLayer;
